import { render, staticRenderFns } from "./DogHeader.vue?vue&type=template&id=d1f4562c&scoped=true"
import script from "./DogHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DogHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DogHeader.vue?vue&type=style&index=0&id=d1f4562c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f4562c",
  null
  
)

export default component.exports